import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, IconButtonOwnProps } from '@mui/material';

type CloseButtonTypes = {
  closeStyle?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  size?: IconButtonOwnProps['size'];
  color?: IconButtonOwnProps['color'];
};

const CloseButton = (props: CloseButtonTypes) => {
  const { closeStyle, onClick, size, color } = props;

  return (
    <IconButton
      data-testid="CloseButton"
      aria-label="close"
      className={closeStyle}
      onClick={onClick}
      size={size || 'large'}
      color={color}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default CloseButton;
